module.exports = __webpack_public_path__ + "img/alert-icon.6716f98e.svg";